import axiosClient, { HOST } from './axiosClient';

const notiService = {
  getListNoti: (params) =>
    axiosClient.get(`${HOST.UTILITIES_SERVICE}/notification-templates?paramKeys=IN_APP`, {
      params,
    }),
  getListEmail: (params) =>
    axiosClient.get(`${HOST.UTILITIES_SERVICE}/notification-templates?paramKeys=EMAIL`, {
      params,
    }),
  getListVariables: (params) =>
    axiosClient.get(`${HOST.UTILITIES_SERVICE}/utilities-meta-data?paramKeys=VARIABLES`, {
      params,
    }),
  updateTemplate: (data) =>
    axiosClient.put(`${HOST.UTILITIES_SERVICE}/notification-templates/${data.id}`, data),
};

export default notiService;
